module.exports = __webpack_public_path__ + "static/media/email.9b35e785.svg";